import { createContext, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

export const PageInfoContext = createContext({});

export const PageInfoContextProvider = ({ children, data = {} }) => {
    const value = useMemo(() => ({ pageInfo: data }), [data]);

    return (
        <PageInfoContext.Provider
            value={value}
        >
            {children}
        </PageInfoContext.Provider>
    );
};

PageInfoContextProvider.propTypes = {
    children: PropTypes.element.isRequired,
    data: PropTypes.object
};

export const usePageInfo = () => useContext(PageInfoContext);
